import { IReinstateablePolicy } from "config";
import { RootState } from "store";

import { createSelector } from "@reduxjs/toolkit";

import { reinstateablePoliciesById } from "./selectReinstateablePolicies";

export const selectReinstatementProductOfferingByPolicyId = createSelector(
  reinstateablePoliciesById,
  (_: RootState, policyId: IReinstateablePolicy["id"]) => policyId,
  (policiesById, policyId) => policiesById[policyId]?.reinstatementRequest?.productsOffering
);
